/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { StackContext } from "../../context";

const itemPageProps = [
  {
    name: "Kohdesivu_Kaupunki",
    resolve: (context: StackContext) => {
      return context.services.dataLayerService?.dataLayer.locationTargeting
        .municipalities;
    },
  },
  {
    name: "Kohdesivu_Maakunta",
    resolve: (context: StackContext) => {
      return (
        context.services.dataLayerService?.dataLayer.locationTargeting
          .regionName ?? ""
      );
    },
  },
  {
    name: "Kohdesivu_Kaupunginosa",
    resolve: (context: StackContext) => {
      return (
        context.services.dataLayerService?.dataLayer.locationTargeting
          .districtName ?? ""
      );
    },
  },
  {
    name: "Kohdesivu_Asuntotyyppi",
    resolve: (context: StackContext) => {
      return context.services.dataLayerService?.dataLayer.propertySubType;
    },
  },
  {
    name: "Kohdesivu_Tuoteryhmä",
    resolve: (context: StackContext) => {
      return context.services.dataLayerService?.dataLayer.propertyType ?? "";
    },
  },
  {
    name: "Kohdesivu_Uudiskohde",
    resolve: (context: StackContext) => {
      return context.services.dataLayerService?.dataLayer.newProperty;
    },
  },
  {
    name: "Kohdesivu_Hinta",
    resolve: (context: StackContext) => {
      return context.services.dataLayerService?.dataLayer.priceItem?.toString(
        10
      );
    },
  },
  {
    name: "Kohdesivu_Huoneluku",
    resolve: (context: StackContext) => {
      return context.services.dataLayerService?.dataLayer.roomCount;
    },
  },
];

export default itemPageProps;
